import React from 'react';
import { NextSeo } from 'next-seo';
import { useUserAgent } from 'next-useragent';
import nookies from 'nookies';
import { RootStoreProvider } from '../providers/RootStoreProvider';
import { Layout } from '../components/Layout';
import { Cities } from '../components/MainPage/Cities';
import { apiProxy } from '../lib/api';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { Collapsed } from '../components/Collapsed';
import { SearchStoreProvider } from '../providers/SearchStoreProvider';
import { logger } from '../lib/logger';
import { serialize } from '../utils/serialize';

export default function Poproutes({
  uaString,
  store: { user, popdirCities },
  canonicalUrl,
}) {
  const ua = useUserAgent(uaString || window.navigator.userAgent);
  const { isMobile, isTablet } = ua;
  const pageRoute = [{ title: 'Популярные круизы', link: '' }];

  const transformData = (captions, bodies) => {
    if (!captions || !bodies) {
      return [];
    }
    return captions?.map((caption, index) => ({
      title: caption,
      body: serialize(bodies[index]),
    }));
  };

  const transformedData = transformData(
    popdirCities.seo_text_caption,
    popdirCities.seo_text,
  );
  console.log(popdirCities, 'popdirCities');

  return (
    <SearchStoreProvider hydrationData={{ user }}>
      <RootStoreProvider hydrationData={{ user }}>
        <NextSeo
          title={popdirCities.seoTitle}
          description={popdirCities.seo_description}
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: '/favicon.ico?v=2',
            },
          ]}
          canonical={canonicalUrl}
        />
        <Layout isMobile={isMobile} isTablet={isTablet}>
          <div className="container--block">
            <div>
              <BreadCrumbs routeCrumbs={pageRoute} />
            </div>
            <Cities
              items={popdirCities.data}
              isMobile={isMobile}
              title={popdirCities.title}
              isRoutes
            />
            {popdirCities.seo_text_caption && popdirCities.seo_text && (
              <div style={{ marginTop: 24 }}>
                <section>
                  <Collapsed items={transformedData} isCruis />
                  <br />
                </section>
              </div>
            )}
          </div>
        </Layout>
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}

export const getServerSideProps = async ctx => {
  const cookies = nookies.get(ctx);
  const { token } = cookies;

  const canonicalUrl = `https://kruiz.online${ctx.req.url}`;
  try {
    const responses = await Promise.allSettled([
      apiProxy.get(`ApiUsers/check_token/${token ?? ''}`, {
        headers: {
          request_id: ctx.req.headers['x-request-id'] ?? 'qwert',
        },
      }),
      apiProxy.get(`ApiPopdir/getPopRoutes`, {
        headers: {
          request_id: ctx.req.headers['x-request-id'] ?? 'qwert',
        },
      }),
    ]);

    const [user, popdirCities] = responses.map(req =>
      req.status === 'fulfilled' ? req.value.data ?? null : null,
    );
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      level: 'debug',
      ym_uid: cookies._ym_uid,
      message: 'poproutes page has been created',
    });
    return {
      props: {
        store: { user, popdirCities },
        uaString: ctx.req.headers['user-agent'],
        canonicalUrl,
      },
    };
  } catch (error) {
    console.log({
      error,
      message: 'Error in getServerSideProps',
      url: ctx.req.url,
    });
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      error,
      level: 'error',
      message: 'poproutes page was not created',
    });
    return {
      redirect: {
        destination: '/503',
        permanent: true,
      },
    };
  }
};
